import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ProductOptionsElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Product Options',
  icon: 'MenuAlt3Icon',
  description: 'A tool for choose options for products during a quotation',
  properties: [
    {
      label: 'Choose Option Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run a product option is chosen',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Product Options Name',
      name: 'componentName',
      editor: 'textbox',
      default: '',
      description: 'The name of the product options component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Edit Mode',
      name: 'isEditMode',
      editor: 'switch',
      default: '',
      description:
        'Set to true to put the component in Edit mode, which displays the Images associated with the category/sub-category',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title',
      name: 'text',
      editor: 'textbox',
      default: '',
      description: 'The title to pass along to the component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'margin',
    'padding'
  ]
};

export default ProductOptionsElementFields;
